/// <reference path="../../typings/externals.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var helper = require('../core/Helper');
var Country = (function (_super) {
    __extends(Country, _super);
    function Country() {
        _super.apply(this, arguments);
    }
    Country.prototype.createUrl = function (options, id) {
        return '/dictionary/country';
    };
    return Country;
})(helper.Helper);
exports.Country = Country;
function $get(context) {
    return context.createSingleton('Country', function () {
        return new Country(context);
    });
}
exports.$get = $get;



/*****************
 ** WEBPACK FOOTER
 ** ./src/lib/helpers/Country.ts
 ** module id = 28
 ** module chunks = 0
 **/